/*@ngInject*/
const PolicyCancellationActionUtil = function ($rootScope, coreConstant, submissionConstant,
                                               uiPerformanceLoggerConstant, loadingBarHandler,
                                               modalUtil, umModalUtil, policyCancellationActionsMediator) {

    this.deleteDraftCancellation = function (submissionId, policyCancellationId) {
        function handleClose() {
            let promise = policyCancellationActionsMediator.deleteDraftCancellation(policyCancellationId).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        modalUtil.showConfirmationModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            'submission.wizard.deleteDraftCancellation',
            uiPerformanceLoggerConstant.DELETE_DRAFT_CANCELLATION,
            /*hideLoadingBar*/false,
            handleClose);
    };

    this.submitForCancellation = function (policyCancellationId) {
        var action = uiPerformanceLoggerConstant.SUBMIT_FOR_CANCELLATION,
            message = policyCancellationId.toString(),
            promise;

        function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }

        loadingBarHandler.showLoadingBar('submission.policy.submitForCancellation');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = policyCancellationActionsMediator.submitForCancellation(policyCancellationId).then(onSuccess, onError).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.markAsCancelled = function (policyCancellationId) {
        var action = uiPerformanceLoggerConstant.MARK_AS_CANCELLED,
            message = policyCancellationId.toString(),
            promise;

        function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }

        loadingBarHandler.showLoadingBar('submission.policy.markAsCancelled');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = policyCancellationActionsMediator.markAsCancelled(policyCancellationId).then(onSuccess, onError).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.revertToCancellationPending = function (submissionId, policyCancellationId) {
        function handleClose(result) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = policyCancellationActionsMediator.revertToCancellationPending(policyCancellationId, result.reason, result.details).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        umModalUtil.showReasonModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            null/*reason*/,
            'submission.wizard.reasonModal.revertToCancellationPendingModal',
            false/*isReasonOptional*/,
            uiPerformanceLoggerConstant.REVERT_TO_CANCELLATION_PENDING,
            handleClose);
    };

    this.rescindCancellation = function (submissionId, policyCancellationId) {
        function handleClose(result) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = policyCancellationActionsMediator.rescindCancellation(policyCancellationId, result.reason, result.details).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        umModalUtil.showReasonModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            null/*reason*/,
            'submission.wizard.reasonModal.rescindCancellationModal',
            false/*isReasonOptional*/,
            uiPerformanceLoggerConstant.RESCIND_CANCELLATION,
            handleClose);
    };

    this.requestCancellation = function (policyCancellationId) {
        var action = uiPerformanceLoggerConstant.REQUEST_CANCELLATION,
            message = policyCancellationId.toString(),
            promise;

        function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }

        loadingBarHandler.showLoadingBar('submission.policy.requestCancellation');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = policyCancellationActionsMediator.requestCancellation(policyCancellationId).then(onSuccess, onError).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.retractCancellationRequest = function (submissionId, policyCancellationId) {
        function handleClose(result) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = policyCancellationActionsMediator.retractCancellationRequest(policyCancellationId, result.reason, result.details).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        umModalUtil.showReasonModal(
            submissionId,
            null/*quoteId*/,
            null,
            null/*reason*/,
            'submission.wizard.reasonModal.retractCancellationRequestModal',
            false/*isReasonOptional*/,
            uiPerformanceLoggerConstant.RETRACT_CANCELLATION_REQUEST,
            handleClose);
    };
};

angular.module('gw-um-submission')
    .service('policyCancellationActionUtil', PolicyCancellationActionUtil);
